import representativeService from '../services/representative.service';

const representatives = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return representativeService.create(model);
        },

        //READ
        get(_, params) {
            return representativeService.get(params.id, params.urlParameters, params.requestId);
        },       
        getlist() {
            return representativeService.getlist();
        },

        //UPDATE
        update(_, model) {
            return representativeService.update(model);
        },

        //DELETE
        delete(_, id) {
            return representativeService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default representatives;
